import AutoAwesome from "@mui/icons-material/AutoAwesome";
import BarChartRounded from "@mui/icons-material/BarChartRounded";
import Edit from "@mui/icons-material/Edit";
import Newspaper from "@mui/icons-material/Newspaper";
import Send from "@mui/icons-material/Send";
import { Box, Typography } from "@mui/material";
import { useDialog } from "../../../../utils/hooks/use-dialog";
import { GradientIcon } from "../../../generic/components/gradient-icon";
import { useCreateSurveyHref } from "../../hooks/use-create-survey-href";
import { CreateButton } from "../create-button";
import { CreateWithAiDialog } from "../create-with-ai-dialog";

import type { FC } from "react";

/** In place of the feed when there's nothing in it: a way to make the first thing. */
export const RecentlyEditedEmpty: FC = () => {
  const withAiDialog = useDialog();
  const createSurveyHref = useCreateSurveyHref();

  return (
    <Box sx={{ textAlign: "center", py: 3 }}>
      <GradientIcon>
        <Edit sx={{ fontSize: 56 }} />
      </GradientIcon>
      <Typography variant="subtitle1" component="p" sx={{ fontWeight: 600, mt: 3, mb: 3 }}>
        Nothing here yet - let’s fix that!
      </Typography>
      <Typography sx={{ mb: 3 }}>
        Create your first communication, newsletter, survey, or design, or let AI whip something up
        for you in seconds.
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", gap: 1.5, flexWrap: "wrap" }}>
        <CreateButton
          label="Create with AI"
          icon={<AutoAwesome />}
          onClick={() => withAiDialog.handleOpen()}
          analyticsId="dashboard-recently-edited-create-with-ai"
        />
        <CreateButton
          label="Communication"
          icon={<Send />}
          href="/moments"
          analyticsId="dashboard-recently-edited-create-communication"
        />
        <CreateButton
          label="Newsletter"
          icon={<Newspaper />}
          href="/moments/newsletter"
          analyticsId="dashboard-recently-edited-create-newsletter"
        />
        <CreateButton
          label="Survey"
          icon={<BarChartRounded />}
          href={createSurveyHref}
          analyticsId="dashboard-recently-edited-create-survey"
        />
      </Box>
      <CreateWithAiDialog dialog={withAiDialog} />
    </Box>
  );
};
